export { ZoomOut as default } from './ZoomOut';
